import { Component, Input, OnInit } from "@angular/core";
import { UserManager } from "../../../business/managers/user.manager";
import { LOGIN_SELECTOR } from "../../../crossconcern/utilities/properties/selector.property";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FormValidatorHelper } from "../../../crossconcern/helpers/validators/formvalidator.helper";
import { AppComponent } from "../../app.component";
import { BaseComponent } from "../../base/base.component";
import { Router } from "@angular/router";
import {
    BACKOFFICE_PATH, NURSERIES_PATH
} from "../../../crossconcern/utilities/properties/path.property";
import { Location } from "@angular/common";
import { finalize } from "rxjs/operators";
import * as version from "../../../../../package.json";
import { logData } from "../../../crossconcern/helpers/generic/generic.helper";
import { AlertUtils } from "../../../crossconcern/utilities/utils/alert.utils";
import {
    BACKOFFICE_LOGIN_USER_UUID,
    AUTOCREATED_INFOPLANT_USER_PASSWORD
} from "../../../crossconcern/utilities/properties/base.property";
import { UserModel } from "../../../datastore/entities/user.model";
import { catchError } from "rxjs/internal/operators";
import { ErrorHandlerHelper } from "../../../crossconcern/helpers/errors/errorhandler.helper";
import { EMPTY } from "rxjs/index";

@Component({
    selector: LOGIN_SELECTOR,
    styles: [],
    templateUrl: "login.component.html"
})
export class LoginComponent extends BaseComponent implements OnInit {

    @Input() public isFrontoffice = true;

    public loginForm: FormGroup;
    public appVersion: string;

    public forcedUsername;
    public forcedPassword;

    constructor(protected appComponent: AppComponent,
        protected router: Router,
        protected location: Location,
        private userManager: UserManager,
        protected formBuilder: FormBuilder,
        protected validator: FormValidatorHelper,
        protected errorHandlerHelper: ErrorHandlerHelper,
        protected alertUtils: AlertUtils) {
        super(appComponent, router, alertUtils, location);
        this.loginForm = formBuilder.group({
            "email": [
                null, ([
                    Validators.required, validator.emailValidator
                ])
            ],
            "password": [
                null
            ]
        });
    }

    public ngOnInit() {
        this.appVersion = version.version;
        if (this.userManager.userIsLogged()) {
            this.goToRoute(BACKOFFICE_PATH);
        }
    }

    public onSubmit() {
        this.appComponent.startLoading();
        if (this.isFrontoffice) {
            this.frontofficeLogin();
        } else {
            this.backofficeLogin();
        }
    }

    private frontofficeLogin() {
        const email = this.loginForm.value.email;
        const password = this.loginForm.value.password;
        // if (email === FRONTEND_LOGIN_USER_EMAIL && password === FRONTEND_LOGIN_USER_PASSWORD) {
        //     this.backofficeLogin();
        // } else {
        this.userManager.login(
            email,
            password)
            .pipe(
                finalize(() => this.appComponent.stopLoading()),
                catchError((err) => {
                    if (err.status === 401) {
                        this.userManager.getInfoPlantUser(email, password)
                            .pipe(finalize(() => this.appComponent.stopLoading()))
                            .subscribe((userAuth: boolean) => {
                                logData("infoplant user logged: ", userAuth);
                                if (userAuth) {
                                    this.forcedUsername = email;
                                    this.forcedPassword = AUTOCREATED_INFOPLANT_USER_PASSWORD;
                                    this.backofficeLogin();
                                } else {
                                    this.alertUtils.showErrorAlert(
                                        "LOGIN_COMPONENT_ERROR_TITLE",
                                        "LOGIN_COMPONENT_ERROR_DESC"
                                    );
                                }
                            });
                    } else {
                        this.errorHandlerHelper.showError(err);
                    }

                    // Return an empty Observable which gets collapsed in the output
                    return EMPTY;
                })
            )
            .subscribe(
                (user: UserModel) => {
                    logData("user just logged", user);
                    this.userManager.updateLoggedUser();

                    if (user.uuid === BACKOFFICE_LOGIN_USER_UUID) {
                        this.goToRoute(BACKOFFICE_PATH);
                    } else {
                        this.goToRoute(NURSERIES_PATH);
                    }
                });

        // }
    }

    private backofficeLogin() {
        const username = (this.forcedUsername) ? this.forcedUsername : this.loginForm.value.email;
        const password = (this.forcedPassword) ? this.forcedPassword : this.loginForm.value.password;
        this.userManager.login(
            username,
            password)
            .pipe(
                finalize(() => this.appComponent.stopLoading()),
                catchError((err) => {
                    if (err.status === 401) {
                        this.userManager.createUser(username)
                            .pipe(catchError((err2) => {
                                this.errorHandlerHelper.showError(err2);
                                return EMPTY;
                            }))
                            .subscribe(() => {
                                this.forcedUsername = username;
                                this.forcedPassword = AUTOCREATED_INFOPLANT_USER_PASSWORD;
                                this.backofficeLogin();
                            });
                    } else {
                        this.errorHandlerHelper.showError(err);
                    }

                    // Return an empty Observable which gets collapsed in the output
                    return EMPTY;
                })
            )
            .subscribe(
                (user: UserModel) => {
                    logData("user just logged", user);
                    this.userManager.updateLoggedUser();

                    if (user.uuid === BACKOFFICE_LOGIN_USER_UUID) {
                        this.goToRoute(BACKOFFICE_PATH);
                    } else {
                        this.goToRoute(NURSERIES_PATH);
                    }
                });
    }
}
